<template>
  <div class="product_details_wrap">
    <PCNavbar :selectIndex="2" />
    <MobileNavBar :currentActive="2" />
    <div class="product_content">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="product_bread">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/product' }">产品中心</el-breadcrumb-item>
        <el-breadcrumb-item>产品详情</el-breadcrumb-item>
      </el-breadcrumb>

      <div v-if="product.name" class="product_detail">
        <!-- 产品头部信息 -->
        <div class="product_header">
          <h1 class="product_title">{{ product.name }}</h1>
          <div class="product_meta">
            <span class="category">{{ product.category?.categoryName || '未分类' }}</span>
            <span class="brand" v-if="product.brand">品牌：{{ product.brand }}</span>
          </div>
        </div>

        <!-- 产品主图 -->
        <div class="product_main_image" v-if="product.image">
          <img :src="product.image" :alt="product.name" />
        </div>

        <!-- 产品价格和规格 -->
        <div class="product_info_box">
          <div class="price_section">
            <span class="price_label">价格：</span>
            <span class="price_value">¥{{ product.price }}</span>
          </div>
          <div class="spec_section" v-if="product.specifications">
            <span class="spec_label">规格：</span>
            <span class="spec_value">{{ product.specifications }}</span>
          </div>
          <div class="sales_section">
            <span class="sales_label">销量：</span>
            <span class="sales_value">{{ product.salesVolume || 0 }}</span>
          </div>
        </div>

        <!-- 产品描述 -->
        <div class="product_section" v-if="product.description">
          <h2 class="section_title">产品描述</h2>
          <div class="section_content">{{ product.description }}</div>
        </div>

        <!-- 产品功效 -->
        <div class="product_section" v-if="product.efficacy">
          <h2 class="section_title">产品功效</h2>
          <div class="section_content">{{ product.efficacy }}</div>
        </div>

        <!-- 产品图片集 -->
        <div class="product_section" v-if="productImages.length > 0">
          <h2 class="section_title">产品图片</h2>
          <div class="product_gallery">
            <div v-for="(img, index) in productImages" :key="index" class="gallery_item">
              <img :src="img" :alt="`${product.name} - 图${index + 1}`" />
            </div>
          </div>
        </div>
      </div>

      <div v-else class="no_product">
        <p>产品不存在或已下架</p>
        <el-button type="primary" @click="goBack">返回产品列表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import { getProductById } from '../../api/product'

export default {
  name: 'ProductDetail',
  components: {
    PCNavbar,
    MobileNavBar
  },
  data() {
    return {
      product: {},
      originalTitle: ''
    }
  },
  computed: {
    productImages() {
      if (this.product.images) {
        return this.product.images.split(',').filter(img => img.trim())
      }
      return []
    }
  },
  mounted() {
    this.originalTitle = document.title
    this.getProductDetail()
  },
  beforeDestroy() {
    if (this.originalTitle) {
      document.title = this.originalTitle
    }
  },
  methods: {
    async getProductDetail() {
      try {
        const res = await getProductById(this.$route.params.id)
        if (res.data && res.data.data) {
          this.product = res.data.data
          this.updatePageTitle()
        }
      } catch (error) {
        console.error('获取产品详情失败:', error)
      }
    },
    updatePageTitle() {
      if (this.product && this.product.name) {
        document.title = this.product.name + ' - 产品详情'
      }
    },
    goBack() {
      this.$router.push('/product')
    }
  },
  watch: {
    '$route'(to, from) {
      if (to.params.id !== from.params.id) {
        this.getProductDetail()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product_details_wrap {
  min-height: 100vh;
  background: #f5f7fa;
}

.product_content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 20px 40px;

  @media screen and (max-width: 768px) {
    padding: 80px 15px 30px;
  }
}

.product_bread {
  font-size: 14px;
  margin-bottom: 20px;
}

.product_detail {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);

  @media screen and (max-width: 768px) {
    padding: 20px 15px;
  }
}

.product_header {
  margin-bottom: 30px;
  border-bottom: 2px solid #f0f0f0;
  padding-bottom: 20px;
}

.product_title {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
}

.product_meta {
  display: flex;
  gap: 20px;
  align-items: center;
  flex-wrap: wrap;
}

.category {
  display: inline-block;
  padding: 6px 16px;
  background: #409eff;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
}

.brand {
  color: #666;
  font-size: 14px;
}

.product_main_image {
  margin: 30px 0;
  text-align: center;

  img {
    max-width: 100%;
    max-height: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
}

.product_info_box {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 25px;
  margin: 30px 0;
  display: flex;
  gap: 40px;
  flex-wrap: wrap;

  @media screen and (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
}

.price_section,
.spec_section,
.sales_section {
  display: flex;
  align-items: center;
}

.price_label,
.spec_label,
.sales_label {
  font-size: 16px;
  color: #666;
  margin-right: 10px;
}

.price_value {
  font-size: 32px;
  font-weight: bold;
  color: #f56c6c;
}

.spec_value,
.sales_value {
  font-size: 16px;
  color: #333;
}

.product_section {
  margin: 30px 0;
  padding: 20px 0;
  border-top: 1px solid #f0f0f0;
}

.section_title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  position: relative;
  padding-left: 15px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px;
    background: #409eff;
    border-radius: 2px;
  }
}

.section_content {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  white-space: pre-wrap;
}

.product_gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 10px;
  }
}

.gallery_item {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  img {
    width: 100%;
    height: 250px;
    object-fit: cover;

    @media screen and (max-width: 768px) {
      height: 150px;
    }
  }
}

.no_product {
  text-align: center;
  padding: 100px 20px;
  background: #fff;
  border-radius: 8px;

  p {
    font-size: 18px;
    color: #999;
    margin-bottom: 20px;
  }
}
</style>
